import { faEnvelope } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useTrackEventMutation } from 'src/common/slices';
import { SignupModal } from 'src/features/signup/components/signup-modal';
import { Button } from '@tryhackme/thm-ui-components';
import { useNavigate } from 'react-router-dom';
import { StyledButtonContainer, StyledButtonSection, StyledContainer, StyledContentWrapper, StyledDescription, StyledFullWidthButton, StyledFullWidthLink, StyledGoogleLogo, StyledHeading, StyledLoginLink, StyledTextSection } from './google-fade-login.styles';
export interface GoogleFadeLoginProps {
  referrer: string | null;
  roomType: 'free' | 'premium';
  roomName: string;
  roomCode: string;
}
export const GoogleFadeLogin = ({
  referrer,
  roomType,
  roomName,
  roomCode
}: GoogleFadeLoginProps) => {
  const navigate = useNavigate();
  const isPremium = roomType === 'premium';
  const [isSignupModalOpen, setIsSignupModalOpen] = useState<boolean>(false);
  const [trackEvent] = useTrackEventMutation();
  const handleSignupClick = () => {
    setIsSignupModalOpen(true);
    handleTrackEvent();
  };
  const handleTrackEvent = () => {
    // eslint-disable-next-line no-void
    void trackEvent({
      event: `${roomType}-room-banner`
    });
  };
  return <>
      <StyledContainer data-sentry-element="StyledContainer" data-sentry-source-file="google-fade-login.tsx">
        <StyledContentWrapper data-sentry-element="StyledContentWrapper" data-sentry-source-file="google-fade-login.tsx">
          <StyledTextSection data-sentry-element="StyledTextSection" data-sentry-source-file="google-fade-login.tsx">
            <StyledHeading data-sentry-element="StyledHeading" data-sentry-source-file="google-fade-login.tsx">Ready to learn Cyber Security? Create your free account today.</StyledHeading>
            <StyledDescription data-sentry-element="StyledDescription" data-sentry-source-file="google-fade-login.tsx">{getRoomCopy(isPremium, roomName)}</StyledDescription>
          </StyledTextSection>

          <StyledButtonSection data-sentry-element="StyledButtonSection" data-sentry-source-file="google-fade-login.tsx">
            <StyledButtonContainer $isPremium={isPremium} data-sentry-element="StyledButtonContainer" data-sentry-source-file="google-fade-login.tsx">
              {isPremium ? <>
                  <Button type="button" variant="outlined" color="primary" onClick={() => {
                handleTrackEvent();
                navigate(`/pricing?roomCode=${roomCode}`);
              }}>
                    Subscribe now
                  </Button>
                  <Button type="button" variant="solid" color="primary" onClick={handleSignupClick}>
                    Join for FREE
                  </Button>
                </> : <>
                  <StyledFullWidthLink to={`/login/google?redirectTo=${encodeURIComponent(referrer ?? '')}`} onClick={handleTrackEvent}>
                    <StyledFullWidthButton type="button" variant="outlined" color="secondary">
                      <StyledGoogleLogo /> Continue with Google
                    </StyledFullWidthButton>
                  </StyledFullWidthLink>

                  <StyledFullWidthButton type="button" variant="outlined" color="secondary" onClick={handleSignupClick}>
                    <FontAwesomeIcon icon={faEnvelope} style={{
                  width: '1.6rem',
                  height: '1.6rem'
                }} /> Continue with
                    email
                  </StyledFullWidthButton>
                </>}
            </StyledButtonContainer>

            <p>
              Already have an account?&nbsp;
              <StyledLoginLink to="/login" onClick={handleTrackEvent} data-sentry-element="StyledLoginLink" data-sentry-source-file="google-fade-login.tsx">
                Log in
              </StyledLoginLink>
            </p>
          </StyledButtonSection>
        </StyledContentWrapper>
      </StyledContainer>
      <SignupModal open={isSignupModalOpen} onOpenChange={setIsSignupModalOpen} data-sentry-element="SignupModal" data-sentry-source-file="google-fade-login.tsx" />
    </>;
};
const getRoomCopy = (isPremium: boolean, roomName: string) => {
  if (isPremium) {
    return `The ${roomName} room is only available for premium users. Signup now to access more than 500 free rooms and learn cyber security through a fun, interactive learning environment.`;
  }
  return 'TryHackMe provides free online cybersecurity training to secure jobs & upskill through a fun, interactive learning environment.';
};